import AppLayout from 'apps/home/components/Layout';
import GuestLayout from 'apps/home/components/LayoutGuest';
import AdminLoginPage from 'apps/home/pages/AdminLogin';
import ChangePassword from 'apps/home/pages/ChangePassword';
import CreatePassword from 'apps/home/pages/CreatePassword';
import Homepage from 'apps/home/pages/Homepage';
import PageNotFound from 'apps/home/pages/PageNotFound';
import AccountSecurity from 'apps/home/pages/AccountSecurity';
import TwoFactor from 'apps/home/pages/TwoFactor';
import accountingRoutes from 'apps/accounting/routes';
import agentRoutes from 'apps/agent/routes';
import catalogRoutes from 'apps/catalog/routes';
import futureflexRoutes from 'apps/futureflex/routes';
import investcoreRoutes from 'apps/investcore/routes';
import investmentRoutes from 'apps/investment/routes';
import nhsvRoutes from 'apps/nhsv/routes';
import roboAdvisoryRoutes from 'apps/robo-advisory/routes';
import wealthRoutes from 'apps/wealth/routes';
import { GuestRoute, PrivateRoute } from 'common/ui/AuthRoute';
import PermissionError from 'common/ui/PermissionError';
import TokenExpiredError from 'common/ui/token-expired';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from 'react-router-dom';

// Backward-compat redirect: /investcore/* → /admin/*
const InvestcoreRedirect = () => {
  const { '*': splat } = useParams();
  return <Navigate to={`/admin/${splat}`} replace />;
};

const AppRouter = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('url') || '/';

  return (
    <>
      <Routes>
        <Route
          element={
            <GuestRoute>
              <GuestLayout />
            </GuestRoute>
          }
        >
          <Route path="/login" element={<AdminLoginPage />} />
        </Route>

        <Route
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/cms" element={<Navigate to="/cms/settings" />} />
          <Route
            path="/robo-advisory"
            element={<Navigate to="/robo-advisory/portfolios" />}
          />
          <Route
            path="/investment"
            element={<Navigate to="/investment/users" />}
          />
          <Route
            path="/admin"
            element={<Navigate to="/admin/home-widgets" />}
          />
          <Route
            path="/catalog"
            element={<Navigate to="/catalog/banks" />}
          />
          <Route path="/investcore" element={<Navigate to="/admin" replace />} />
          <Route path="/investcore/*" element={<InvestcoreRedirect />} />
          <Route
            path="/nhsv"
            element={<Navigate to="/nhsv/home" />}
          />
          <Route
            path="/wealth"
            element={<Navigate to="/wealth/programs" />}
          />
          <Route
            path="/accounting"
            element={<Navigate to="/accounting/home" />}
          />
          <Route
            path="/futureflex"
            element={<Navigate to="/futureflex/home" />}
          />

          <Route path="/home" element={<Homepage />} />

          {roboAdvisoryRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}

          {investmentRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {investcoreRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {catalogRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {nhsvRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {wealthRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {accountingRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {futureflexRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}
          {agentRoutes.map(e => (
            <Route key={e?.path} {...e} />
          ))}

          <Route path="/permission" element={<PermissionError />} />
          <Route path="/expired" element={<TokenExpiredError />} />

          <Route path="/404" element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />

          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/security" element={<AccountSecurity />} />
          <Route path="/two-factor" element={<TwoFactor />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRouter;
